<template>
  <div class="container-fluid">
    <div class="row pb-2" v-show="!editMode || (editMode && editFull)">
      <div class="col-7 col-no-padding">
        <form class="form">
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.label") }}</label>
            <input
              ref="label"
              type="text"
              v-model="label"
              class="form-input col-12"
              :class="isLabelMissing && 'invalid'"
            />
            <p v-if="isLabelMissing" class="text-danger-600 m-0">
              {{ $t("validation.required_field") }}
            </p>
          </div>
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.address") }}</label>
            <div class="col-12 simple-checkbox" v-if="parentIsSite">
              <input
                type="checkbox"
                name="sameAddress"
                id="sameAddress"
                v-model="siteAddressChecked"
                @change="siteAddress"
              /><label for="sameAddress">{{
                $t("plans.form.sameAddress")
              }}</label>
            </div>
            <div class="col-12">
              <AddressField
                :address="address"
                :fullAddress="address"
                :disabled="siteAddressChecked"
                @location="handleLocation"
                @centerMap="handleMapCenter"
              ></AddressField>
            </div>
          </div>
        </form>
      </div>
      <div class="col-5 col-no-padding">
        <MiniMap
          ref="minimap"
          :id="'minimap-building'"
          :center="center"
          :zoom="zoom"
        ></MiniMap>
      </div>
    </div>
    <div class="row pb-2" v-show="editMode && !editFull">
      <div class="col-12 col-no-padding">
        <form class="form">
          <div class="form-row row">
            <label class="col-12">{{ $t("plans.form.label") }}</label>
            <input
              type="text"
              v-model="label"
              class="form-input col-12"
              :class="isLabelMissing && 'invalid'"
            />
            <p v-if="isLabelMissing" class="text-danger-600 m-0">
              {{ $t("validation.required_field") }}
            </p>
          </div>
        </form>
      </div>
    </div>
    <Toolbar class="not-fixed p-4 justify-content-end">
      <Btn class="primary" @click.native.stop="handleSave">
        {{ $t("global.save") }}
      </Btn>
      <Btn @click.native.stop="cancel">
        {{ $t("global.cancel") }}
      </Btn>
    </Toolbar>
  </div>
</template>

<script>
import Toolbar from "@/components/ui/Toolbar";
import AddressField from "@/components/ui/fields/AddressField";
import Btn from "@/components/ui/Button";
import MiniMap from "@/components/plans/map/MiniMap";

export default {
  components: {
    Toolbar,
    Btn,
    MiniMap,
    AddressField,
  },
  computed: {
    parentIsSite: function () {
      if (this.site && this.site.type == 2) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
      label: "",
      obj: null,
      center: null,
      zoom: null,
      address: "",
      siteAddressChecked: false,
      editMode: false,
      editFull: false,
      isLabelMissing: false,
    };
  },
  methods: {
    resetForm: function () {
      this.label = "";
      this.siteAddressChecked = false;
      this.isLabelMissing = false;
      this.siteAddress();
    },
    cancel: function () {
      this.resetForm();
      this.$emit("close", "add", "building");
    },
    handleLocation: function (location) {
      this.address = location.address;
      this.center = location.center;
      this.zoom = 16;
    },
    handleMapCenter: function (location) {
      this.center = location.center;
      this.zoom = location.zoom;
    },
    handleSave: function () {
      if (this.label.length == 0) {
        this.isLabelMissing = true;
        return;
      } else {
        this.isLabelMissing = false;
        this.valid();
      }
    },
    valid: function () {
      if (this.editMode) {
        this.obj.name = this.label;
        if (this.editFull) {
          this.obj.where = {
            point: {
              lng: this.$refs.minimap.map._map.getCenter().lng,
              lat: this.$refs.minimap.map._map.getCenter().lat,
            },
            addressLabel: this.address,
          };
          this.obj.zoom = this.$refs.minimap.map._map.getZoom();
        }
        this.$emit("editBuilding", this.obj);
      } else {
        var obj = {
          type: 4,
          name: this.label,
          where: {
            point: {
              lng: this.$refs.minimap.map._map.getCenter().lng,
              lat: this.$refs.minimap.map._map.getCenter().lat,
            },
            addressLabel: this.address,
          },
          zoom: this.$refs.minimap.map._map.getZoom(),
        };

        this.$emit("addBuilding", obj);
      }
      //this.resetForm();
    },
    siteAddress: function () {
      if (this.siteAddressChecked) {
        this.address = this.site.where.addressLabel;
        this.handleMapCenter({
          center: {
            lng: this.site.where.point.lng,
            lat: this.site.where.point.lat,
          },
          zoom: 16,
        });
      } else {
        this.address = "";
      }
    },
    edit: function (edit, obj) {
      if (edit == null) {
        edit = false;
      }
      this.editFull = false;
      this.editMode = edit;
      if (obj != null) {
        this.obj = obj;
        this.label = obj.name;
        if (obj.where) {
          if (obj.where.point) {
            this.center = {
              lng: obj.where.point.lng,
              lat: obj.where.point.lat,
            };
          }
          if (obj.where.addressLabel) {
            this.address = obj.where.addressLabel;
          }
        }
        if (obj.zoom) {
          this.zoom = obj.zoom;
        }
        if (
          !obj.hasAPs &&
          (!obj.children || (obj.children && obj.children.length == 0))
        ) {
          this.editFull = true;
        }

        this.$nextTick(() => {
          if (
            this.$refs.minimap &&
            this.$refs.minimap.map &&
            this.$refs.minimap.map._map &&
            this.center
          ) {
            this.$refs.minimap.map._map.flyTo({
              center: this.center,
              zoom: this.zoom || this.$refs.minimap.map._map.getZoom(),
              speed: 1,
            });
          }
        });
      }
      if (!edit) {
        this.$refs.label.focus();
      }
    },
  },
  name: "",
  props: ["site"],
  watch: {
    label: function (newVal) {
      if (newVal.length > 0) {
        this.isLabelMissing = newVal.length == 0;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
